import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'time',
    standalone: true
})
export class TimePipe implements PipeTransform {

  transform(value: unknown | any, ...args: unknown[]): unknown | any {

    // var display = moment().seconds(value).format("H:mm:ss");
    function pad(num) {
      return ("0"+num).slice(-2);
    }
    function hhmmss(secs) {
      var minutes = Math.floor(secs / 60);
      secs = secs%60;
      var hours = Math.floor(minutes/60);
      minutes = minutes%60;
      return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
      // return pad(hours)+":"+pad(minutes)+":"+pad(secs); for old browsers
    }
    return hhmmss(value);
  }

}
